import React, { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { BackButton } from '../components/BackButton'
import { PageContainer } from '../components/layout/PageContainer'
import YesNoAction from '../components/YesNoAction'
import { TestIds } from '../testIds'
import { Button } from '../components/Button'

export const QuoteOrderSubmitted = () => {
  const navigate = useNavigate()

  // TODO: use when can redirect to specific order
  // const location = useLocation()

  // Access the quote object from state
  // const { quote } = (location.state as { quote: Quote }) || {}
  //
  const onClick = () => {
    // navigate(`/order/${quote.orderId}`, {
    //   state: {
    //     quote: quote,
    //   },
    // })

    navigate(`/orders`)
  }

  const cartOrMessage = useMemo(() => {
    return (
      <YesNoAction
        display='Order submitted!'
        subheading={
          <Typography variant='body2' sx={{ mt: 4, mb: 2 }}>
            Your order is submitted. We’ve also sent you an email confirmation. Before your order is
            processed we will reach out to confirm any additional delivery costs, if applicable.
          </Typography>
        }
        body={
          <Box>
            <Button variant='contained' onClick={onClick}>
              View Orders
            </Button>
          </Box>
        }
      />
    )
  }, [])

  return (
    <PageContainer data-testid={TestIds.pages.quoteOrderSubmitted}>
      <BackButton text='Quotes' onClick={() => navigate('/quotes')} />
      {cartOrMessage}
    </PageContainer>
  )
}
